import { RatePlan } from "../pages/customerSettings/RatePlans";

export function displayWalletRates(basePlans: RatePlan[], country?: string) {
  let ratePlans = [...basePlans];

  if (
    (process.env.REACT_APP_FF_DISPLAY_GOOGLEPAY?.toLowerCase() ?? "false") ===
    "true"
  ) {
    ratePlans = [...ratePlans, { id: "googlepay", label: "Google Pay" }];
  }

  if (
    (process.env.REACT_APP_FF_DISPLAY_APPLEPAY?.toLowerCase() ?? "false") ===
    "true"
  ) {
    ratePlans = [...ratePlans, { id: "applepay", label: "Apple Pay" }];
  }

  if (
    (process.env.REACT_APP_FF_DISPLAY_PAYPAL?.toLowerCase() ?? "false") ===
    "true"
  ) {
    ratePlans = [...ratePlans, { id: "paypal", label: "PayPal" }];
  }

  // Australian users (country = "AU") - Include JCB, EFTPOS & CUP payment methods
  if (country === "AU") {
    // Exclude ACH payment method
    ratePlans = ratePlans.filter((plan) => plan.id.toLowerCase() !== "ach");

    if (!ratePlans.some((plan) => plan.id === "jcb")) {
      ratePlans = [...ratePlans, { id: "jcb", label: "JCB" }];
    }
    if (!ratePlans.some((plan) => plan.id === "eftpos_australia")) {
      ratePlans = [...ratePlans, { id: "eftpos_australia", label: "EFTPOS" }];
    }
    if (!ratePlans.some((plan) => plan.id === "cup")) {
      ratePlans = [...ratePlans, { id: "cup", label: "CUP" }];
    }
  }

  return ratePlans;
}
